export default __webpack_public_path__ + "images/CI.e5f6176.png";